// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"4efb160d61859352","3468":"414c7efc01838865"}[chunkId] + ".css";
};